import styled from "styled-components";

export const ICardAnnounceStyled = styled.div<{img: string}>`
  display: flex;
  width: 446px;
  height: 226px;
  border-radius: 10px;
  margin-right: 19px;
  background-image: url(${props => props.img});
  object-fit: cover;
  background-repeat: no-repeat;
  align-items: flex-end;
  justify-content: flex-start;
  cursor: pointer;


  @media screen and (min-width: 1221px) {
    width: 600px;
    height: 300px;
    background-size: 600px 300px;
  }

  @media screen and (max-width: 1520px) {
    width: 400px;
    background-size: 400px;
     height: 200px;
  }

  @media screen and (max-width: 1220px) {
    width: 500px;
    background-size: 600px;
  }

  @media screen and (max-width: 620px) {
    width: 355px;
    height: 200px;
     background-size: 355px;
  }

`;

export const BodyAnnounce = styled.div `
    margin: 20px;   
    color: white;
`;